import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { useContent } from "@/context/ContentContext";
import { Instagram, Mail, Phone } from "lucide-react";

export default function Footer({ onOpenCookie }) {
  const { t } = useLanguage();
  const { content } = useContent();
  const contact = content.contact || {};
  const year = new Date().getFullYear();

  const navLinks = [
    { to: "/ueber-uns", label: t("nav.about") },
    { to: "/packages", label: t("nav.packages") },
    { to: "/services", label: t("nav.services") },
    { to: "/eindruecke", label: t("nav.impressions") },
    { to: "/faq", label: t("nav.faq") },
    { to: "/kontakt", label: t("nav.contact") },
  ];

  return (
    <footer data-testid="footer" className="bg-ink text-cream pt-20 pb-10 px-6 lg:px-10">
      <div className="max-w-[1400px] mx-auto grid md:grid-cols-4 gap-12 mb-16">
        <div className="md:col-span-1">
          <img src="/fotos/logo.png?v=3" alt="Our Promise Events" className="h-24 w-auto mb-5" />
          <p className="text-sm text-cream/70 leading-relaxed">{t("footer.claim")}</p>
        </div>

        <div>
          <p className="text-xs tracking-[0.25em] uppercase text-gold mb-5">{t("footer.nav")}</p>
          <ul className="space-y-3 text-sm text-cream/80">
            {navLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="elegant-link hover:text-cream">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs tracking-[0.25em] uppercase text-gold mb-5">{t("footer.contact")}</p>
          <ul className="space-y-3 text-sm text-cream/80">
            <li>
              <a href={`mailto:${contact.email || "info@ourpromiseevents.com"}`} className="flex items-center gap-2 hover:text-cream" data-testid="footer-email">
                <Mail size={15} /> {contact.email || "info@ourpromiseevents.com"}
              </a>
            </li>
            <li>
              <a href={`tel:${(contact.phone || "+41794848597").replace(/\s/g, "")}`} className="flex items-center gap-2 hover:text-cream" data-testid="footer-phone">
                <Phone size={15} /> {contact.phone || "+41 79 484 85 97"}
              </a>
            </li>
            <li>
              <a href={contact.instagram || "https://instagram.com"} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-cream" data-testid="footer-instagram">
                <Instagram size={15} /> {contact.instagram_handle || "Instagram"}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs tracking-[0.25em] uppercase text-gold mb-5">{t("footer.legal")}</p>
          <ul className="space-y-3 text-sm text-cream/80">
            <li><Link to="/impressum" className="elegant-link hover:text-cream" data-testid="footer-impressum">{t("footer.imprint")}</Link></li>
            <li><Link to="/datenschutz" className="elegant-link hover:text-cream" data-testid="footer-privacy">{t("footer.privacy")}</Link></li>
            <li><button onClick={onOpenCookie} className="elegant-link hover:text-cream" data-testid="footer-cookies">{t("footer.cookies")}</button></li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto border-t border-cream/15 pt-8 text-xs tracking-wider text-cream/60 text-center">
        © {year} Our Promise Events — {t("footer.rights")}
      </div>
    </footer>
  );
}
